<mat-card appearance="outlined" class="mt-3">
  <div class="row m-3">
    <div tabindex="0" class="col-12" [class.col-md-6]="!!actionLabel">
      <mat-card-subtitle *ngIf="label" class="subscription-card__label" [innerHTML]="label"></mat-card-subtitle>
      <mat-card-title>{{ subscription.productDescription }}</mat-card-title>
      <ng-container *ngIf="!titleOnly">
        <mat-card-subtitle *ngIf="subscription.subId"
                           [innerHTML]="translationService.getTranslation('order_id') + ': ' + subscription.subId">
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="subscription.userBackendId"
                           [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + subscription.userBackendId">
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="subscription.variantDescription"
                           [innerHTML]="translationService.getTranslation('order_edition') + ': ' + subscription.variantDescription">
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="subscription.validDate" [innerHTML]="translationService.getTranslation('period') + ': ' +
                                 (subscription.validDate.validFrom | date) + ' - ' +
                                 ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date) : translationService.getTranslation('subscription_endless'))">
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="subscription.curDelivery">
          {{ subscription.curDelivery.person.addressCodeDescription }}
          {{ subscription.curDelivery.person.firstname }}
          {{ subscription.curDelivery.person.lastname }},
          {{ subscription.curDelivery.address.city }},
          {{ subscription.curDelivery.address.street }} {{ subscription.curDelivery.address.houseno | houseNoPipe }}
        </mat-card-subtitle>
      </ng-container>
    </div>
    <div class="col-12 col-md-6" *ngIf="actionLabel">
      <mat-card-actions class="card-actions">
        <button mat-raised-button color="primary" [innerHTML]="actionLabel"
                (click)="action.emit(subscription)"></button>
      </mat-card-actions>
    </div>
  </div>
  <!-- Inhalt des Aufrufers unter den Abodaten, z. B. die zubuchbaren Angebote der Zubucherseite -->
  <ng-content></ng-content>
</mat-card>
